import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
body{
    /* background:#e1f0ef; */
    width: fit-content;
    margin: 0;
    box-sizing: border-box;
    height: fit-content;
    font-family: 'Poppins', sans-serif;
}
`;

export default GlobalStyle;
